import { ReadMoreExpandable } from "@wags/ui/read-more-expandable.tsx";
import { renderProviderAboutLink } from "./provider-about-link";

export function AboutSection({
    providerId,
    description,
}: {
    providerId: string;
    description: string;
}) {
    return (
        <section className="lg:grid lg:grid-cols-[280px_minmax(0,1fr)] lg:items-start lg:gap-x-16">
            <h2 className="text-section-title text-doberman-black text-balance">
                About us
            </h2>
            <ReadMoreExpandable
                lines={8}
                viewportFraction={0.58}
                renderPhoneLink={renderProviderAboutLink(providerId)}
                contentClassName="mt-4 max-w-prose whitespace-pre-line break-words lg:mt-0"
            >
                {description}
            </ReadMoreExpandable>
        </section>
    );
}
